<template>
  <div class="row mt-1">
    <div class="col-md-6">
      <a-skeleton active v-if="loading" />
      <a-form :form="form" v-else>
        <div class="row">
          <div class="col-md-6">
            <a-form-item
              :label="$t('bulletinBuilder.afficherIdentifiantUnique')"
            >
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'headers.uniqueIden',
                    {
                      initialValue: affichageData.headers.uniqueIden,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('bulletinBuilder.afficherNbInscription')">
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'headers.nbInscription',
                    {
                      initialValue: affichageData.headers.nbInscription,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('bulletinBuilder.afficherDateNaissance')">
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'headers.birthDate',
                    {
                      initialValue: affichageData.headers.birthDate,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('bulletinBuilder.hideSubModuleMark')">
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'body.hideSubModuleMark',
                    {
                      initialValue: affichageData.body.hideSubModuleMark,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('bulletinBuilder.afficherCache')">
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'side.stamp',
                    {
                      initialValue: affichageData.side.stamp,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('bulletinBuilder.afficherDate')">
              <div class="d-flex align-items-center">
                <a-switch
                  v-decorator="[
                    'side.printDate',
                    {
                      initialValue: affichageData.side.printDate,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </div>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </div>

    <!-- Preview Section -->
    <div class="col-md-6 mt-1">
      <div class="preview-container">
        <div class="preview-header">
          <h3 class="preview-title">{{ $t("bulletinBuilder.apercuBulletin") }}</h3>
          <div class="preview-controls">
            <div class="preview-actions">
              <a-select
                :placeholder="$t('bulletinBuilder.selectionnerEleve')"
                class="preview-select"
                allow-clear
                @change="selectStudent"
                v-model="studentID"
              >
                <a-select-opt-group
                  v-for="classroom in Object.values(students)"
                  :key="classroom.classRoomID"
                >
                  <span slot="label">{{ classroom.classRoom }}</span>
                  <a-select-option
                    v-for="student in classroom.students"
                    :key="student._id"
                    :value="student._id"
                  >
                    {{ student.firstName }} {{ student.middleName }} {{ student.lastName }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
              <div class="preview-buttons">
                <a-button
                  type="primary"
                  icon="reload"
                  class="preview-btn"
                  @click="renderPDF"
                >
                  {{ $t("bulletinBuilder.actualiser") }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-content">
          <iframe
            v-if="pdfVisible"
            class="preview-iframe"
            :src="pdfBlobUrl"
            style="width: 100%; height: calc(100vw * 1.4142); max-height: 95vh"
          />
          <div v-else class="preview-placeholder">
            <a-spin v-if="pdfLoading" size="large" />
            <div v-else class="preview-empty">
              <a-icon type="file-pdf" class="preview-icon" />
              <p class="preview-text">
                {{ $t("bulletinBuilder.selectionnerElevePourVisualiser") }}
              </p>
              <a-button type="primary" @click="renderPDF">
                <a-icon type="eye" />
                {{ $t("bulletinBuilder.visualiserBulletin") }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="col-md-2 offset-md-6 mt-3">
      <a-popconfirm
        v-if="!isReadOnly"
        :title="$t('all.sureToCancelAlert')"
        :ok-text="$t('all.oui')"
        :cancel-text="$t('all.non')"
        @confirm="undo"
      >
        <a-button type="danger" class="w-100">
          <a-icon type="undo" />
          {{ $t("all.cancel") }}
        </a-button>
      </a-popconfirm>
      <a-button v-else type="danger" class="w-100" :disabled="true">
        <a-icon type="undo" />
        {{ $t("all.cancel") }}
      </a-button>
    </div>
    <div class="col-md-4 mt-3">
      <a-button type="primary" class="w-100" @click="saveConfig" :disabled="isReadOnly">
        <a-icon type="save" />
        {{ $t("all.save") }}
      </a-button>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
const lodash = require("lodash");
import { mapState, mapGetters } from "vuex";
import peda from "../../../../bulletinv2/studentMarks/scripts/bulletinHeplers/peda";

export default {
  name: "SysGestLMSSpec",
  props: {
    affichageData: {
      type: Object,
      required: true,
    },
    studentData: {},
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    templateList: {
      type: Array,
    },
    certifParams: {
      type: Array,
    },
    students: {
      type: Object,
    },
    studentsKey: {
      type: Number,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.displaySettings;
      return value === "ro";
    },
  },
  data() {
    return {
      pdfVisible: false,
      pdfLoading: false,
      pdfBlobUrl: null,
      studentID: null,
      selectedStudent: null,
      form: this.$form.createForm(this),
      bulletinData: null,
    };
  },
  watch: {
    affichageData: {
      handler() {
        this.form.setFieldsValue({
          headers: {
            uniqueIden: this.affichageData.headers?.uniqueIden,
            nbInscription: this.affichageData.headers?.nbInscription,
            birthDate: this.affichageData.headers?.birthDate,
          },
          side: {
            stamp: this.affichageData.side?.stamp,
            printDate: this.affichageData.side?.printDate,
          },
          body: {
            hideSubModuleMark: this.affichageData.body?.hideSubModuleMark,
          },
        });
      },
    },
  },
  methods: {
    // Form handling
    handleSubmit() {},
    resetForm() {},

    // PDF generation and preview
    async renderPDF() {
      if (this.selectedStudent && this.bulletinData) {
        await this.validateConfig();
        console.log(this.affichageData);
        const schoolDetails = this.user.building.filter(
          (el) => el.dbName == this.settings.activeBuilding
        )[0];

        let { start, end } = this.settings.schoolarYears.find(
          (el) => el._id == this.settings.activeSchoolarYear
        );

        start = new Date(start).getFullYear();
        end = new Date(end).getFullYear();

        const schoolarYearName = end + " / " + start;
        const bloburl = await peda.printBulletin(
          this.affichageData,
          this.selectedStudent,
          this.bulletinData,
          {
            selectedLevel: Number(this.affichageData.level),
            schoolDetails: schoolDetails,
            settings: this.settings,
            schoolarYearName: schoolarYearName,
            selectedTrimester: this.affichageData.trimester,
            selectedClasse: this.bulletinData.selectedClasse,
            selectedClassName: this.bulletinData.classroomName,
            certifs: this.certifParams,
          },
          true
        );
        this.pdfBlobUrl = bloburl;
        this.pdfVisible = true;
      } else {
        this.$message.info(this.$t("bulletinBuilder.selectStudentFirst"));
      }
    },
    async selectStudent(studentID) {
      if (studentID) {
        for (let classRoomStudent of Object.values(this.students)) {
          let studentData = classRoomStudent.students.find(
            (s) => s._id == studentID
          );
          if (studentData) this.selectedStudent = studentData;
          break;
        }

        if (this.selectedStudent._id) {
          await apiClient
            .get(
              `bulletin/v2/bt/${this.affichageData.type}/${studentID}/${this.affichageData.trimester}`
            )
            .then(async ({ data }) => {
              this.bulletinData = data;
              await this.renderPDF();
            })
            .catch((e) => {
              console.info(e);
              this.$message.error(
                this.$t("bulletinBuilder.errorGettingBulletinData")
              );
            });
        }
      }
    },

    // Configuration management
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    async saveConfig() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let reqData = values;
          let reqOK = null;
          if (this.affichageData._id) {
            const id = this.affichageData._id;
            await apiClient
              .patch("/bulletin/v2/affichage/" + id, {
                ...reqData,
                trimester: Number(this.affichageData.trimester),
                level: Number(this.affichageData.level),
                type: this.affichageData.type,
                schoolarYear: this.affichageData.schoolarYear,
              })
              .then(({ data }) => {
                reqOK = data;
                delete reqOK.createdAt;
                delete reqOK.updatedAt;
                delete reqOK.__v;
              })
              .catch((e) => {
                console.info(e);
                this.handleApiError(e, this.$t("bulletinBuilder.parametresNonEnregistres"));
              });
          } else {
            await apiClient
              .put("/bulletin/v2/affichage/", {
                ...reqData,
                trimester: Number(this.affichageData.trimester),
                level: Number(this.affichageData.level),
                type: this.affichageData.type,
                schoolarYear: this.affichageData.schoolarYear,
              })
              .then(({ data }) => {
                reqOK = data;
              })
              .catch((e) => {
                console.info(e);
                this.handleApiError(e, this.$t("bulletinBuilder.parametresNonEnregistres"));
              });
          }
          if (reqOK) {
            this.$emit("update:affichageData", reqOK);
            this.$message.success(this.$t("bulletinBuilder.parametresEnregistresAvecSucces"));
          }
        }
      });
    },
    undo() {},

    // Utility methods
    formatData() {},
    async validateConfig() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit("update:affichageData", values);
        }
      });
    },
  },
};
</script>
